import clone from 'lodash.clonedeep';
import OrderedMap from 'orderedmap';
import { Schema } from 'prosemirror-model';
var getSpecFromMap = function (origin) {
    if (origin.nodes instanceof OrderedMap && origin.marks instanceof OrderedMap) {
        var obj_1 = { nodes: {}, marks: {} };
        origin.nodes.forEach(function (name, spec) { return (obj_1.nodes[name] = spec); });
        origin.marks.forEach(function (name, spec) { return (obj_1.marks[name] = spec); });
        return obj_1;
    }
    return origin;
};
var updateSchema = function (origin, patches) {
    var newSchema = clone(getSpecFromMap(origin));
    patches
        .filter(function (p) { return p && p.name; })
        .reduce(function (res, cur) {
        var name = cur.name;
        var type = cur.getDisplay();
        var spec = res[type];
        spec[name] && console.warn('repeat registration', name);
        spec[name] = cur.config;
        return res;
    }, newSchema);
    return newSchema;
};
var createSchema = function (schema) { return new Schema(schema); };
export { createSchema, updateSchema };
//# sourceMappingURL=normalize.js.map